import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { EnumMeasureTypes } from '@library/store/measures/measures.interface';
import { CpForecastService } from '@pages/control-page/control-page-main/control-page-dashboard/control-page-body/control-page-forecast/cp-forecast-service';
import * as moment from 'moment-timezone';

@Component({
  selector: 'app-cp-forecast-tab-today',
  templateUrl: './cp-forecast-tab-today.component.html',
  styleUrl: './cp-forecast-tab-today.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CpForecastTabTodayComponent {

  forecast = inject(CpForecastService).forecast;

  forecastGraphs = computed(() => {
    const forecastGraphs =  this.forecast().forecastGraphs;
    return forecastGraphs.temperature.map((_, i) => {
      return {
        temperature: forecastGraphs.temperature[i],
        humidity: forecastGraphs.humidity[i],
        wind: forecastGraphs.wind[i],
        rain: forecastGraphs.rain[i],
        symbol: forecastGraphs.symbol[i],
      };
    }).filter((graph) => {
      return moment(graph.temperature[0] * 1000).isAfter(moment());
    });
  });

  EnumMeasureTypes = EnumMeasureTypes;

  getTime(time: number): string {
    return moment(time * 1000).format('LT');
  }

}
